<template>
	<Layout>
		<div class="directory-container">
			<div class="container">
				<div class="navbar-group justify-space-between flex-wrap gap-2">
					<div><LeadModal /></div>

					<div style="flex-grow: 1; max-width: 100%; position: relative">
						<v-text-field
							style="width: 350px; max-width: 100%; margin-left: auto"
							class="custom-input"
							label="Search Leads"
							variant="outlined"
							bg-color="white"
							color="gray300"
							density="comfortable"
							v-model="state.search"
							clearable
							data-cy="lead-search-input"
						>
							<template #append-inner>
								<div class="d-flex align-center">
									<v-icon>mdi-magnify</v-icon>
									<v-menu
										location="bottom right"
										@update:model-value="state.showSelectionMenu = $event"
									>
										<template #activator="{ props }">
											<v-icon
												v-bind="props"
												class="ml-2"
												data-cy="lead-filter-menu"
											>
												mdi-menu-down
											</v-icon>
										</template>
										<v-list>
											<v-list-item
												active-color="primary"
												:active="state.filter === 'active'"
												value="active"
												data-cy="lead-filter-active"
												@click="state.filter = 'active'"
											>
												Active
											</v-list-item>
											<v-list-item
												active-color="primary"
												:active="state.filter === 'suppressed'"
												value="suppressed"
												data-cy="lead-filter-suppressed"
												@click="state.filter = 'suppressed'"
											>
												Suppressed
											</v-list-item>
											<v-list-item
												active-color="primary"
												:active="state.filter === 'all'"
												value="all"
												data-cy="lead-filter-all"
												@click="state.filter = 'all'"
											>
												All
											</v-list-item>
										</v-list>
									</v-menu>
								</div>
							</template>
						</v-text-field>
					</div>
				</div>
				<LeadsDirectory
					:search="state.search || ''"
					:filter="state.filter"
					@update:search="state.search = $event"
				/>
			</div>
		</div>
	</Layout>
</template>

<script setup lang="ts">
import Layout from "@/views/support/Layout.vue";
import LeadsDirectory from "@/components/support/LeadsDirectory.vue";
import LeadModal from "@/components/support/LeadModal.vue";
import { reactive } from "vue";

const state = reactive({
	search: "",
	showSelectionMenu: false,
	filter: "active" as "active" | "suppressed" | "all",
});
</script>

<style scoped lang="scss">
.directory-container {
	padding: 20px 30px 0;
}
</style>
